import { gsap } from "gsap";
import lw from 'lottie-web'
import { ScrollTrigger } from "gsap/ScrollTrigger.js"
gsap.registerPlugin(ScrollTrigger)




// LOTTIES

if (document.querySelector('.lottie--combating')) {
  lw.loadAnimation({
    container: document.querySelector('.lottie--combating'), // the dom element that will contain the animation
    renderer: 'svg',
    loop: true,
    autoplay: true,
    path: '/assets/BOE_22_003_health_security_230201.json' // the path to the animation json
  });
}

if (document.querySelector('.lottie--aging-pets')) {
  lw.loadAnimation({
    container: document.querySelector('.lottie--aging-pets'), // the dom element that will contain the animation
    renderer: 'svg',
    loop: true,
    autoplay: true,
    path: '/assets/BOE_22_003_story-what-do-aging-pets-need_hero_230126.json' // the path to the animation json
  });
}

if (document.querySelector('.lottie--grandmother-hero')) {
  lw.loadAnimation({
    container: document.querySelector('.lottie--grandmother-hero'), // the dom element that will contain the animation
    renderer: 'svg',
    loop: true,
    autoplay: true,
    path: '/assets/BOE_22_003_Friendship-Bench_Hero-Grafik.json' // the path to the animation json
  });
}

if (document.querySelector('.lottie--grandmother-depr')) {
  lw.loadAnimation({
    container: document.querySelector('.lottie--grandmother-depr'), // the dom element that will contain the animation
    renderer: 'svg',
    loop: true,
    autoplay: true,
    path: '/assets/BOE_22_003_story-when-grandmothers-safe-lifes_depression_220112.json' // the path to the animation json
  });
}

if (document.querySelector('.lottie--grandmother-end')) {
  lw.loadAnimation({
    container: document.querySelector('.lottie--grandmother-end'), // the dom element that will contain the animation
    renderer: 'svg',
    loop: true,
    autoplay: true,
    path: '/assets/BOE_22_003_Friendship-Bench_end.json' // the path to the animation json
  });
}


if (document.querySelector('.lottie--winwin--1')) {
  lw.loadAnimation({
    container: document.querySelector('.lottie--winwin--1'), // the dom element that will contain the animation
    renderer: 'svg',
    loop: true,
    autoplay: true,
    path: '/assets/BOE_22_003_story-a-classic-win-win_cancer-research_230113.json' // the path to the animation json
  });
}

if (document.querySelector('.lottie--winwin--2')) {
  lw.loadAnimation({
    container: document.querySelector('.lottie--winwin--2'), // the dom element that will contain the animation
    renderer: 'svg',
    loop: true,
    autoplay: true,
    path: '/assets/BOE_22_003_story-a-classic-win-win_immune-disorders_230113.json' // the path to the animation json
  });
}

if (document.querySelector('.lottie--winwin--3')) {
  lw.loadAnimation({
    container: document.querySelector('.lottie--winwin--3'), // the dom element that will contain the animation
    renderer: 'svg',
    loop: true,
    autoplay: true,
    path: '/assets/BOE_22_003_story-a-classic-win-win_stress+anxiety_230113.json' // the path to the animation json
  });
}

if (document.querySelector('.aging-pets__image--1')) {
  lw.loadAnimation({
    container: document.querySelector('.aging-pets__image--1'), // the dom element that will contain the animation
    renderer: 'svg',
    loop: true,
    autoplay: true,
    path: '/assets/BOE_22_003_Aging-Pets_People_Alison_230203.json' // the path to the animation json
  });
}

if (document.querySelector('.aging-pets__image--2')) {
  lw.loadAnimation({
    container: document.querySelector('.aging-pets__image--2'), // the dom element that will contain the animation
    renderer: 'svg',
    loop: true,
    autoplay: true,
    path: '/assets/BOE_22_003_Aging-Pets_People_Aurora_230203.json' // the path to the animation json
  });
}


if (document.querySelector('.aging-pets__image--3')) {
  lw.loadAnimation({
    container: document.querySelector('.aging-pets__image--3'), // the dom element that will contain the animation
    renderer: 'svg',
    loop: true,
    autoplay: true,
    path: '/assets/BOE_22_003_Aging-Pets_People_Cesar_230203.json' // the path to the animation json
  });
}

if (document.querySelector('.aging-pets__image--4')) {
  lw.loadAnimation({
    container: document.querySelector('.aging-pets__image--4'), // the dom element that will contain the animation
    renderer: 'svg',
    loop: true,
    autoplay: true,
    path: '/assets/BOE_22_003_Aging-Pets_People_Stephanie_230203.json' // the path to the animation json
  });
}



  if (document.querySelector('.combating-teaser')) {
    console.log(document.querySelector('.combating-teaser';
    lw.loadAnimation({
      container: document.querySelector('.combating-teaser'), // the dom element that will contain the animation
      renderer: 'svg',
      loop: true,
      autoplay: true,
      path: '/assets/BOE_22_003_health_security_teaser_230314.json' // the path to the animation json
    });
  }






// Cloud Computing
var cloud_slides =  document.querySelectorAll('.quantum-computing__slider');
if (cloud_slides) {
  cloud_slides.forEach(function (cloud_slide) {
    var cloud_dot =  cloud_slide.querySelector('.quantum-computing__slider__dot');
    ScrollTrigger.create({
      trigger: cloud_slide,
      start: "top center", 
      end: "bottom center",
      pin: cloud_dot,
      pinReparent: true
    });

  }
}









